import { DATASET } from '@utils/constants';

/* eslint-disable import/prefer-default-export */
export const lineChartReqBody = {
  // modify properties, as required before making API request
  queries: [
    {
      type: 'timeseries',
      dataset: DATASET,
      metrics: ['RebufferingRatio', 'VideoStartFailures', 'VideoStartTime'],
      interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
      granularity: 'PT1H',
      filter: [],
      options: {
        withTotals: true,
      },
    },
  ],
};
